import apiClient from './api';
import type {
  InventoryValueResponse,
  MarginByProductResponse,
  MarginReportResponse,
  ReportGroupBy,
} from '../types/report';

export const marginReportService = {
  // GET /api/activities/reports/margin
  getReport: async (
    companyId: number,
    from: string,
    to: string,
    groupBy: ReportGroupBy
  ): Promise<MarginReportResponse> => {
    const response = await apiClient.get<MarginReportResponse>('/activities/reports/margin', {
      params: { companyId, from, to, groupBy },
    });
    return response.data;
  },

  // GET /api/activities/reports/margin/by-product
  getReportByProduct: async (
    companyId: number,
    from: string,
    to: string
  ): Promise<MarginByProductResponse> => {
    const response = await apiClient.get<MarginByProductResponse>('/activities/reports/margin/by-product', {
      params: { companyId, from, to },
    });
    return response.data;
  },

  // GET /api/activities/reports/inventory-value
  getInventoryValue: async (
    companyId: number,
    from: string,
    to: string
  ): Promise<InventoryValueResponse> => {
    const response = await apiClient.get<InventoryValueResponse>('/activities/reports/inventory-value', {
      params: { companyId, from, to },
    });
    return response.data;
  },
};
